/* ============
 * Create Page
 * ============
 *
 * This is the page for adding product group.
 */
import { mapGetters } from 'vuex';
import productTagService from './../../../../services/productTag';
import productTagTransformer from './../../../../transformers/productTag';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        tag: {
          value: '',
          type: 'text',
        },
      }),
      tabIndex: '1',
    };
  },

  created() {
   
  },

  computed: {
    
  },

  methods: {
    /**
     * Method to store the product group.
     */
    store() {
      this.form.loading = true;
      const productTag = productTagTransformer.send(this.form.data());
      productTagService.store(productTag)
      .then(() => {
        this.form.loading = false;
        this.$message({
            message: this.$t('static.productTags.create.success'),
            type: 'success',
        });
        this.$router.push({
            name: 'productTags.index',
        });
      }).catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },
  },

  watch: {
   
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/productTag/create/create.js